<template>
  <div id="app">
    <router-view v-if="!isIpadHeng" :key="new Date()+'1'" />
    <div class="ipadHp" v-else>
      <div><img src="./assets/hp.png" alt=""></div>
      <span>请切换竖屏浏览！</span></div>
  </div>
</template>

<script>
import { asyncSave } from "@/api/publishOnline"
export default {
  name: "App",
  data(){
    return{
      isIpadHeng:false,
      pathArr:[
        // PCPath： PC端路由；mPath：移动端路由
        {pcPath: '/indexs',mPath:'/mHome'}, //首页
        {pcPath: '/architecturepublishing',mPath:'/architecturalbooksh5'}, // 建筑图书
        {pcPath: '/subjectLibrary',mPath:'/mSubject'}, // 专题列表
        {pcPath: '/subjectDetail',mPath:'/mSubjectDetails'}, // 专题详情
        {pcPath: '/commodity-list',mPath:'/goodsresult'}, // 搜索结果页
        {pcPath: '/commodity-details',mPath:'/mgoodsInfo'}, // 商品详情页
        {pcPath: '/courseDetail',mPath:'/mgoodsInfo'}, // 商品详情页
        {pcPath: '/packageDetails',mPath:'/mgoodsInfo'}, // 商品详情页
        {pcPath: '/player',mPath:'/mgoodsInfo'}, // 播放页
        {pcPath: '/news',mPath:'/announcement'}, // 新闻列表页
        {pcPath: '/newsdetails',mPath:'/announcementInfo'}, // 新闻详情页
        {pcPath: '/authorList',mPath:'/mAuthorList'}, // 专家列表页
        {pcPath: '/authorDetail',mPath:'/mAuthorDetails'}, // 专家详情页
        {pcPath: '/active_news',mPath:'/m_active_news'}, // 二建活动页
        {pcPath: '/digitalTextbooks',mPath:'/mDigitalTextbooks'}, // 数字图书
        {pcPath: '/active_news_yj',mPath:'/m_active_news_yj'}, // 一建活动页
      ]
    }
  },
  watch: {
    $route: {
      handler: function(to, from) {
        // alert(1)
        let thePath = to.path
        let fullPath = to.fullPath
        if(thePath ===  '/mhome'){
          thePath='/mHome'
          fullPath='/mHome'
        }
        // if(!window.matchMedia("(orientation: portrait)").matches && !this.isiPad()){
        //   //横屏 提示
        //   this.isIpadHeng = true
        // }
        for(let i=0;i<this.pathArr.length;i++){
          if(thePath == this.pathArr[i].pcPath){
        // console.log('路径233356',this.pathArr[i].pcPath)
            if(/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent) || this.isiPad()) {
              // alert(1)
              let mPath = fullPath.replace(this.pathArr[i].pcPath, this.pathArr[i].mPath)
              // if(thePath == '/personalOrder'){
              //   window.location.href = process.env.SSO_WEB_URL + mPath + '?index=0'
              // }
              // else{
                window.location.href = process.env.CBZX_PLATFORM_PATH + mPath
              // }
              // console.log('路径2333m',mPath)
            } else {
              return;
            }
            // return mPath;
          }
          if(thePath == this.pathArr[i].mPath){
              // alert(3)
             if(/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent) || this.isiPad()) {
           // if(this.identifyDevicePlatform() == 'mobile' || this.identifyDevicePlatform() == 'pad'){
              return;
            } else {
              // alert(2)
              let pcPath;
              if(thePath == '/mgoodsInfo'){
                pcPath = fullPath.replace(thePath, '/commodity-details')
              }else{
                pcPath = fullPath.replace(this.pathArr[i].mPath, this.pathArr[i].pcPath)
              }
              // let pcPath = fullPath.replace(this.pathArr[i].mPath, this.pathArr[i].pcPath)
              // if(thePath == '/mOrderList'){
              // window.location.href = process.env.SSO_WEB_URL + '/personalOrder'
              // }
              // else{
              window.location.href = process.env.CBZX_PLATFORM_PATH + pcPath
              // }
              // console.log('路径2333pc',pcPath)
            }
            // return mPath;
          }
          // break
        }






        let url = process.env.LIB_PLATFORM_PATH+to.path
        let name = to.meta.title
        if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          // return;
          this.getAsyncSave(url,name,'mweb')
        } else {
          this.getAsyncSave(url,name,'PC')
          // let pcPath = fullPath.replace(this.pathArr[i].mPath, this.pathArr[i].pcPath)
          // window.location.href = process.env.LIB_PLATFORM_PATH + pcPath
          // console.log('路径2333pc',pcPath)
        }
      }
    }
  },
  mounted(){
    // window.addEventListener("resize", () => {
    //  let tempMatches
    //  if(window.matchMedia("(orientation: portrait)").matches){
    //     if(window.matchMedia("(orientation: portrait)").matches != tempMatches){
    //         //true 竖屏
    //        // this.isIpadHeng = false   //隐藏
    //         window.location.href =  `${process.env.CBZX_PLATFORM_PATH}/mHome`
    //     }
    //  }else{
    //       //false 横屏
    //        window.location.href =  `${process.env.CBZX_PLATFORM_PATH}/indexs`
    //       // if(!this.isiPad())return
    //      // this.isIpadHeng = true //显示
    //  }
    //  tempMatches = window.matchMedia("(orientation: portrait)").matches
    // })
  },
  methods:{
    getAsyncSave(url,name,platform){
      let params = {}
      let paramsBody = {
        appCode: 'cbzx',
        url: url,
        name: name,
        platform: platform
      }
      asyncSave(params,paramsBody).then(res=>{
        console.log('resresres',res.data)
      })
    },
    isiPad() {
        return (/macintosh|mac os x/i.test(navigator.userAgent) && window.screen.height > window.screen.width && !navigator.userAgent.match(/(iPhone\sOS)\s([\d_]+)/)) || navigator.userAgent.match(/(iPad).*OS\s([\d_]+)/);
    }
  }
};
</script>

<style>
/* @media print {*{display:none !important;}} */
html {
  overflow-y: scroll;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  /* filter: grayscale(100%); */
}
body {
  position: relative;
  padding: none;
}

img {
  vertical-align: middle;
}
ul {
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
.ipadHp{
  position: relative;
  height: 100vh;
  width: 100%;
  background: #000 !important;
  color: #fff;
  font-size: 36px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.ipadHp > div{margin-bottom: 20px;}
</style>



// WEBPACK FOOTER //
// src/App.vue